"use client";

import type { DayOfWeek } from "@/lib/types";
import SellLocationField from "@/components/listing/SellLocationField";
import type { HierarchicalLocationOnChange } from "@/lib/locationIds";
import type { SellProfileLocation } from "@/lib/listing/listingLocationIds";
import PickupScheduleFields from "@/components/listing/PickupScheduleFields";

export interface CommonFieldsSectionProps {
  location: string;
  locationError?: string;
  profileLocation?: SellProfileLocation | null;
  /** @deprecated Prefer `profileLocation`. */
  userLocation?: string;
  onLocationChange: HierarchicalLocationOnChange;
  pickupDays: DayOfWeek[];
  pickupStartHour: string;
  pickupEndHour: string;
  onDayToggle: (day: DayOfWeek) => void;
  onPickupStartHourChange: (v: string) => void;
  onPickupEndHourChange: (v: string) => void;
}

export default function CommonFieldsSection({
  location,
  locationError,
  profileLocation,
  userLocation,
  onLocationChange,
  pickupDays,
  pickupStartHour,
  pickupEndHour,
  onDayToggle,
  onPickupStartHourChange,
  onPickupEndHourChange,
}: CommonFieldsSectionProps) {
  return (
    <div className="space-y-8 rounded-xl border border-primary-100 bg-gradient-to-b from-primary-50/80 to-secondary/50 p-5 shadow-sm">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-primary-800 mb-1">
          Step 1 · Shared for every listing
        </p>
        <h2 className="text-lg font-semibold text-foreground">
          Location &amp; pickup
        </h2>
        <p className="text-sm text-text-light mt-1">
          You only enter this once. It applies to all items in this batch.
        </p>
      </div>
      <SellLocationField
        value={location}
        onChange={onLocationChange}
        error={locationError}
        profileLocation={profileLocation}
        userLocation={userLocation}
      />
      <PickupScheduleFields
        pickupDays={pickupDays}
        pickupStartHour={pickupStartHour}
        pickupEndHour={pickupEndHour}
        onDayToggle={onDayToggle}
        onPickupStartHourChange={onPickupStartHourChange}
        onPickupEndHourChange={onPickupEndHourChange}
      />
    </div>
  );
}
